import { NotificationService } from '../../ui-components/services/notification-service';
import { persistNotification } from './notification-hub.actions';
import { NOTIFICATION_HUB_CONFIG } from './notification-hub-config';
import type { NotificationType, NotificationHubInfo } from './notification-hub.types';

type Dispatch = (action: { type: string; [key: string]: unknown }) => void;

type HubConfig = {
  notificationType: NotificationType;
  defaultTitle: string;
  defaultDescription: string;
  metadataJson?: string;
};

// Mirrors @typedef NotificationConfig from notification-service.js
type ToastConfig = {
  title?: string | JSX.Element;
  content?: string | JSX.Element;
  notificationType?: string;
  notificationId?: string;
  dontHide?: boolean;
  duration?: number;
  progressPercentage?: number;
  [key: string]: unknown;
};

class NotificationHubServiceClass {
  private dispatch: Dispatch | null = null;

  initialize(storeDispatch: Dispatch) {
    this.dispatch = storeDispatch;
  }

  /**
   * Persist to hub, optionally showing a toast.
   * - Hub + toast: showNotification(hubConfig, toastConfig)
   * - Hub only: showNotification(hubConfig)
   */
  showNotification(hubConfig: HubConfig, toastConfig?: ToastConfig): string | null {
    if (this.dispatch) {
      const configEntry = NOTIFICATION_HUB_CONFIG[hubConfig.notificationType]!;
      const hubInfo: NotificationHubInfo = {
        notificationType: hubConfig.notificationType,
        category: configEntry.category,
        priority: configEntry.priority,
        title: hubConfig.defaultTitle,
        description: hubConfig.defaultDescription,
        metadataJson: hubConfig.metadataJson,
      };
      this.dispatch(persistNotification(hubInfo));
    }

    if (toastConfig) {
      return NotificationService.showNotification(toastConfig);
    }

    return null;
  }
}

export const NotificationHubService = new NotificationHubServiceClass();
